var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/HelpCenterMenu.js",
  _this = this;
import React from 'react';
import { createURL } from '@sm/utils';
import Menu from './components/Menu.js';
import { helpCenterMenu } from '../../config/linkInfo';
export var HelpCenterMenu = function HelpCenterMenu() {
  var path = createURL('https://help.surveymonkey.com/', {
    ut_source: 'megamenu'
  });
  var key = 'Help Center';
  return /*#__PURE__*/React.createElement(Menu, Object.assign({}, helpCenterMenu(), {
    path: path,
    menuKey: key,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 7
    }
  }));
};
export default HelpCenterMenu;
//# sourceMappingURL=HelpCenterMenu.js.map